export default __webpack_public_path__ + "static/media/5_1_hl.c6a363f3.png";